import initWebViewMethods from './utils/initWebViewMethods.ts';

import AuthProvider from './context/AuthContext.tsx';

import useAppInit from './hooks/useAppInit.ts';
import { Toaster } from 'react-hot-toast';
import { initTracker } from './utils/analyticsUtils.ts';

initWebViewMethods();

const App = () => {
  useAppInit();
  initTracker();
  return (
    <main className="max-w-3xl px-5 overflow-x-clip no-scrollbar">
      <AuthProvider />
      <Toaster
        position="bottom-center"
        toastOptions={{
          error: {
            style: {
              background: '#EE4F5E',
              color: '#fff',
              fontWeight: '600',
            },
          },
        }}
      />
    </main>
  );
};

export default App;
